/**
 * Módulo que gerencia o estado das mensagens exibidas na aplicacao
 * @state Estados que devem ser controlados
 * @mutations Funções que tem permissão para alterar o state
 * @actions Executar operações asincronas e chamar mutations
 * @getters Retorna o estado além da possibilidade de retornar a
 * mesma lógica do computed (Gera valores com base em valores originais)
 */

const state = {
	columns: [],
}

const mutations = {
	/**
	 * Seta as colunas do arquivo
	 */
	mutationSetColumns: (state, columns) => (state.columns = columns),
}

const actions = {}

const getters = {
	/**
	 * Retorna as colunas do arquivo
	 */
	getColumns: (state) => state.columns,
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
